import { useCallback, useEffect, useRef, useState } from "react";
import BasicTable from "../../../components/Table/BasicTable.jsx";
import BreadCrumb from "../../../components/BreadCrumb.jsx";
import AddGIV from "./AddGIV.jsx";
import { InventoryApi } from "../../../apis/inventory.api.js";
import {
  columns,
  searchBy,
} from "../../../service/GIVInventoryService.js";
import ArticleModel from "../../Account/ArticleModel.jsx";

const GIV = ({ disabledFilters }) => {
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });

  const handlePagination = (data) => {
    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }

    setPagination((prev) => {
      let copyfilter = { ...prev.filter };

      if (data.filter) {
        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(
            data.filter
          )[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }

      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };

  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);
  const [selectedCell, setSelectedCell] = useState(null);
  const [ModalOpen, setModalOpen] = useState(false);
  const [editRolePermissions, setEditRolePermissions] = useState(null);
  const [allGivData, setAllGivData] = useState(null);
  const [isArticleOpen, setIsArticleOpen] = useState(false);
  const [description, setDescription] = useState(null);

  const getAllGRV = async () => {
    try {
      const res = await InventoryApi.getAllGIV(pagination, search);
      setAllGivData(res?.data?.data);
    } catch (error) {
      console.log("Erorr", error);
    }
  };


  const closeRoleModal = () => {
    setModalOpen(false);
    setEditRolePermissions(null);
  };

  const handleRowClick = (row) => {
    setSelectedCell(row);
    setModalOpen(true);
  };

  const handleCellClick = (cell, field = "") => {
    if (field === "viewDetails") {
      setModalOpen(true);
      setEditRolePermissions(cell);
    } else if (field === "description") {
      setIsArticleOpen(true);
      setDescription(cell);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    setSearch("");
    handlePagination && handlePagination(clearPagination);
  };

  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }
    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllGRV();
  }, [pagination, search]);

  console.log("edit permition", editRolePermissions);

  return (
    <div className="p-5">
      <BreadCrumb title={"Goods Issue Voucher"} />
      <BasicTable
        columns={columns}
        data={allGivData?.goodIssuedVouchers || []}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: 1,
          rows: 5, 
          sortField: null,
          sortOrder: null,
          totalPages: 1,
          totalCount: 1,
        }}
        onCellClick={(e) => console.log("Cell Data", e)}
        handleSearch={debouncedSearch}
        SearchBy={searchBy}
        handleFilter={handleFilter}
        handleClearFilter={handleClearFilter}
        selectedData={selectedCell}
        handleCellClick={handleCellClick}
        button_name="Add GIV"
        handleButton={() => {
          setModalOpen(true);
        }}
      />
      <AddGIV
        getAllData={getAllGRV}
        data={editRolePermissions}
        open={ModalOpen}
        handleClose={closeRoleModal}
      />
      {isArticleOpen && (
        <ArticleModel
          data={description?.itemDetails?.[0]?.itemDescription}
          title="Description"
          onClose={() => setIsArticleOpen(false)}
        />
      )}
    </div>
  );
};

export default GIV;
